
import './App.css';
import { Navbar } from './Components/Navbar';
import { Pages } from './Pages/Pages';

function App() {
  return (
    <>
    <Navbar/>
    <Pages/>
    </>
  );
}

export default App;
